

import React from 'react';



import { Table, Tag } from 'antd';



import { formatDouble } from 'utils/utils';



import { renderOrderStatus } from 'renderers/OrderStatusRenderer';



import OrderInformationPanel from 'components/OrderInformationPanel';



import './OrdersTable.scss';



import { displayNumberWithComma } from '../utils/utils';



import moment from 'moment';



import { deleteOrderAttachedFile, getOrderAttachedFiles } from '../api/api';



import { displayError, displayGenericError } from '../common/notifications';



import Icon from 'antd/es/icon';



import Button from 'antd/es/button';



import Empty from 'antd/es/empty';



import { FormattedMessage } from 'react-intl';



import withUseIntl from 'components/withUseIntl';







class OrdersTable extends React.Component {



  state = {



    expandedRowKeys: [],



    width: '0',



    orderPaymentSlip: [],



    selectedRows: [],



    selectedRowKeys: [],



    rowSelection: null,



    totalSourceAmount: 0,



    totalConvertedAmount: 0,



    totalTargetAmount: 0,



    totalRemitFees: 0,

    sortOrder: null,

    sortField: null,

    sortCount: 0,



  };



  componentDidMount() {



    this.updateDimensions();



    window.addEventListener('resize', this.updateDimensions.bind(this));



  }







  componentWillUnmount() {



    window.removeEventListener('resize', this.updateDimensions.bind(this));



  }







  updateDimensions() {



    this.setState({ width: window.innerWidth });



  }







  onRowClicked = (order) => {



    let newExpandedRowKeys = this.state.expandedRowKeys;



    if (newExpandedRowKeys.includes(order.id)) {



      var index = newExpandedRowKeys.indexOf(order.id);



      if (index !== -1) {



        newExpandedRowKeys.splice(index, 1);



      }



    } else {



      newExpandedRowKeys.push(order.id);



    }



    this.setState({



      expandedRowKeys: newExpandedRowKeys,



    });



    this.getOrderAttached(order);



  };







  handleRemoveFile = (orderId, id) => {



    deleteOrderAttachedFile(orderId, id).then((response) => {



      let temp = this.state.orderPaymentSlip.filter((item) => item.id !== id);



      this.setState({



        orderPaymentSlip: temp,



      });



    });



  };







  getOrderAttached = (order) => {



    getOrderAttachedFiles(order.id)



      .then((response) => {



        let orderAttachmentFiles = response;



        let invoices = response.filter((file) => file.attachedFileType === 'CUSTOMER_PAYMENT_SLIP');



        let temp = this.state.orderPaymentSlip;



        if (invoices.length > 0) {



          let orderPaymentSlip = this.state.orderPaymentSlip.filter((item) => item.id === invoices[0].id);



          if (orderPaymentSlip.length === 0) {



            for (var i = 0; i < invoices.length; i++) {



              var invoiceAlreadyDisplayed = false;



              for (var j = 0; j < temp.length; j++) {



                if (temp[j].id === invoices[i].id) {



                  invoiceAlreadyDisplayed = true;



                }



              }



              if (!invoiceAlreadyDisplayed) {



                invoices[i].orderId = order.id;



                temp.push(invoices[i]);



              }



            }



            orderPaymentSlip = temp;



          }



        }



        this.setState({



          orderPaymentSlip: temp,



          orderAttachmentFiles: orderAttachmentFiles,



        });



      })



      .catch((error) => {



        this.setState({



          isLoading: false,



        });



        displayGenericError(error);



      });



  };



  sendEventToGA = (action, category, label, value) => {

    if (window.gtag) {

      // console.log(`Sending GA event - Action: ${action}, Category: ${category}, Label: ${label}, Value: ${value}`);

      window.gtag('event', action, {

        'event_category': category,

        'event_label': label,

        'value': value

      });

    } else {

      // console.error("gtag not available at the time of event triggering.");

    }

  }



  handleTableChange = (pagination, filters, sorter) => {

    const { sortField, sortOrder, sortCount } = this.state;

    let newSortField = sorter.field || 'orderId';

    let newSortOrder = sortOrder;

    let newSortCount = sortField === newSortField ? sortCount + 1 : 1;



    if (newSortCount % 3 === 1) {

      newSortOrder = 'asc';

    } else if (newSortCount % 3 === 2) {

      newSortOrder = 'desc';

    } else {

      newSortOrder = null;

      newSortField = null;

      newSortCount = 0;

    }

    this.setState({

      sortOrder: newSortOrder,

      sortField: newSortField,

      sortCount: newSortCount,

    }, () => {

      this.props.onChange(pagination, filters, { order: newSortOrder, field: newSortField });

      this.sendEventToGA('Manage Order Sort', 'OrdersTable', `${newSortField} sorted ${newSortOrder}`, newSortCount);

    });

  };

  render() {

    const intl = this.props.useIntl;

    let currentUser = this.props.customer;



    let isPartner = null;



    if (currentUser && currentUser.customerTierName && currentUser.customerTierName.includes('PARTNER')) {



      isPartner = true;



    }



    let columns = [

      {
        title: () => (
            <div>
              {intl.formatMessage({ id: 'app.table.orderstable.orderid' })}
            </div>
        ),
        dataIndex: 'orderId',
        key: 'orderId',
        sorter: (a, b) => a.orderId.localeCompare(b.orderId, undefined, { numeric: true }),
        width: '180px',
      },
      {



        title: intl.formatMessage({ id: 'app.table.orderstable.orderdate' }),



        dataIndex: 'dateCreated',



        key: 'orderDate',



        sorter: (a, b) => new Date(a.dateCreated) - new Date(b.dateCreated),



        render: (dateCreated) => `${moment(dateCreated).format('DD/MMM/YYYY')}`,



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.beneficiaryname' }),



        dataIndex: 'beneficiaryName',



        key: 'beneficiaryName',



        sorter: (a, b) => a.beneficiaryName.localeCompare(b.beneficiaryName),



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.amountpaid' }),



        dataIndex: 'sourceAmount',



        key: 'sourceAmount',



        sorter: (a, b) => a.sourceAmount - b.sourceAmount,



        render: (text, record) => (



          <span>{displayNumberWithComma(record.sourceAmount, 2)} {record.sourceCurrency}</span>



        ),



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.fee' }),



        dataIndex: 'fee',



        key: 'fee',



        render: (text, record) => (



          <span>{displayNumberWithComma(record.fee, 2)} {record.sourceCurrency}</span>



        ),



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.exchangerate' }),



        dataIndex: 'exchangeRate',



        key: 'exchangeRate',



        render: (text, record) => (



          <span>{formatDouble(record.exchangeRate, 4)}</span>



        ),



      },







      {



        title: intl.formatMessage({ id: 'app.table.orderstable.beneficiarygets' }),



        dataIndex: 'targetAmount',



        key: 'targetAmount',



        render: (text, record) => (



          <span>{displayNumberWithComma(record.targetAmount, 2)} {record.targetCurrency}</span>



        ),



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.status' }),



        dataIndex: 'orderStatus',



        key: 'orderStatus',



        render: (text, record) => renderOrderStatus(text),



      },



    ];







    let columnsPartner = [



      {



        title: () => (



          <div>



            {intl.formatMessage({ id: 'app.table.orderstable.orderid' })}



            <div style={{ fontSize: '0.83em' }}>/ {intl.formatMessage({ id: 'app.table.orderstable.partnertxnid' })}</div>



          </div>



        ),



        dataIndex: 'orderId',



        key: 'orderId',



        sorter: (a, b) => a.orderId.localeCompare(b.orderId, undefined, { numeric: true }),



        width: '180px',



        render: (text, record) => {



          if (record.partnerTxnId) {



            return (



              <div>



                {text}



                <div style={{ fontSize: '0.83em' }}>/ {record.partnerTxnId}</div>



              </div>



            );



          }



          return <div>{text}</div>;



        },



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.orderdate' }),



        dataIndex: 'dateCreated',



        key: 'orderDate',



        sorter: (a, b) => new Date(a.dateCreated) - new Date(b.dateCreated),



        render: (dateCreated) => `${moment(dateCreated).format('DD/MMM/YYYY')}`,



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.sendername' }),



        dataIndex: 'originatorDisplayName',



        key: 'originatorDisplayName',



        sorter: (a, b) => {



          const nameA = a.originatorDisplayName || '';



          const nameB = b.originatorDisplayName || '';



          return nameA.localeCompare(nameB);



        },



        render: (text, record) => {



          if (text) {



            return <span>{text}</span>;



          } else {



            if (currentUser.corporateAccountDetails) {



              return <span>{currentUser.corporateAccountDetails.nameOfBusiness}</span>;



            }



          }



          return <></>;



        },



      },



      {

        title: intl.formatMessage({ id: 'app.table.orderstable.beneficiaryname' }),

        dataIndex: 'beneficiaryName',

        key: 'beneficiaryName',

        sorter: (a, b) => {

          const nameA = a.beneficiary ? a.beneficiaryName : '';

          const nameB = b.beneficiary ? b.beneficiaryName : '';

          return nameA.localeCompare(nameB);

        },

      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.amountpaid' }),



        dataIndex: 'sourceAmount',



        key: 'sourceAmount',



        sorter: (a, b) => a.sourceAmount - b.sourceAmount,



        render: (text, record) => (



          <span>{displayNumberWithComma(record.sourceAmount, 2)} {record.sourceCurrency}</span>



        ),



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.fee' }),



        dataIndex: 'fee',



        key: 'fee',



        render: (text, record) => (



          <span>{displayNumberWithComma(record.fee, 2)} {record.sourceCurrency}</span>



        ),



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.exchangerate' }),



        dataIndex: 'exchangeRate',



        key: 'exchangeRate',



        render: (text, record) => {



          if (record.indicativeOrder) {



            return (



              <Tag color="green" style={{ fontSize: '14px' }}>



                {formatDouble(record.exchangeRate, 4)}



                <Icon type="exclamation-circle" style={{ margin: '4px' }} />



              </Tag>



            );



          } else {



            return <span>{formatDouble(record.exchangeRate, 4)}</span>;



          }



        },



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.beneficiarygets' }),



        dataIndex: 'targetAmount',



        key: 'targetAmount',



        render: (text, record) => (



          <span>{displayNumberWithComma(record.targetAmount, 2)} {record.targetCurrency}</span>



        ),



      },



      {



        title: intl.formatMessage({ id: 'app.table.orderstable.status' }),



        dataIndex: 'orderStatus',



        key: 'orderStatus',



        render: (text, record) => renderOrderStatus(text),



      },



    ];







    const isMobile = this.state.width <= 767;



    if (isMobile) {



      columns = [



        {



          title: intl.formatMessage({ id: 'app.table.orderstable.name' }),



          dataIndex: 'beneficiaryName',



          key: 'beneficiaryName',



        },



        {



          title: intl.formatMessage({ id: 'app.table.orderstable.gets' }),



          dataIndex: 'targetAmount',



          key: 'targetAmount',



          render: (text, record) => (



            <span>{displayNumberWithComma(record.targetAmount, 2)} {record.targetCurrency}</span>



          ),



        },



        {



          title: intl.formatMessage({ id: 'app.table.orderstable.status' }),



          dataIndex: 'orderStatus',



          key: 'orderStatus',



          render: (text, record) => renderOrderStatus(text),



        },



      ];



    }



    let locale = {



      emptyText: <Empty description={intl.formatMessage({ id: 'app.message.orderstable.createfirsttransaction' })} />,



    };



    let rowSelection = null;



    let labelCancel = intl.formatMessage({ id: 'app.table.orderstable.cancelorder' });







    if (



      this.props.customer.approval &&



      this.props.customer.roleResources.filter((s) => s.name === 'APPROVER' || s.name === 'AUTHORIZER').length > 0



    ) {



      labelCancel = intl.formatMessage({ id: 'app.table.orderstable.rejectorder' });



    }



    if (



      (this.props.customer.approval &&



        this.props.customer.roleResources.filter(



          (s) => s.name === 'FULL_ACCESS' || s.name === 'APPROVER' || s.name === 'APPROVER_EXT' || s.name === 'AUTHORIZER'



        ).length > 0) ||



      this.props.showSelectOrderCheckbox



    ) {



      let orderStatusDisabled = [];



      if (this.props.customer.roleResources.filter((s) => s.name === 'APPROVER' || s.name === 'APPROVER_EXT').length > 0) {



        orderStatusDisabled.push('PENDING_APPROVAL');



      }



      if (this.props.customer.roleResources.filter((s) => s.name === 'AUTHORIZER' || s.name === 'APPROVER_EXT').length > 0) {



        orderStatusDisabled.push('PENDING_AUTHORIZE');



      }



      if (this.props.customer.roleResources.filter((s) => s.name === 'FULL_ACCESS').length > 0) {



        orderStatusDisabled.push('PENDING_APPROVAL');



        orderStatusDisabled.push('PENDING_AUTHORIZE');







        if (this.props.showSelectOrderCheckbox) {



          orderStatusDisabled.push('RECEIVED');



        }



      }







      rowSelection = {



        selectedRowKeys: this.props.selectKeys,



        getCheckboxProps: (record) => ({



          disabled: !(



            (record.orderStatus === 'PENDING_APPROVAL' ||



              record.orderStatus === 'PENDING_AUTHORIZE' ||



              (record.orderStatus === 'RECEIVED' && record.indicativeOrder && record.transferMode === 'SOURCE')) &&



            orderStatusDisabled.includes(record.orderStatus)



          ),



          name: record.name,



        }),



        onChange: (selectedRowKeys, selectedRows) => {



          var totalSourceAmount = 0;



          var totalConvertedAmount = 0;



          var totalTargetAmount = 0;



          var totalRemitFees = 0;







          for (var i = 0; i < selectedRows.length; i++) {



            totalSourceAmount = totalSourceAmount + selectedRows[i].requestedAmount;



            totalConvertedAmount = totalConvertedAmount + selectedRows[i].convertedAmount;



            totalTargetAmount = totalTargetAmount + selectedRows[i].targetAmount;



            totalRemitFees = totalRemitFees + selectedRows[i].fee;



          }







          this.setState(



            {



              selectedRows: selectedRows,



              selectedRowKeys: selectedRowKeys,



              totalSourceAmount: totalSourceAmount,



              totalConvertedAmount: totalConvertedAmount,



              totalTargetAmount: totalTargetAmount,



              totalRemitFees: totalRemitFees,



            },



            function () {



              this.props.selectedOrderRowKeys({



                order: this.state.selectedRowKeys,



                selectedOrders: this.state.selectedRows,



                totalSourceAmount: this.state.totalSourceAmount,



                totalConvertedAmount: this.state.totalConvertedAmount,



                totalTargetAmount: this.state.totalTargetAmount,



                totalRemitFees: this.state.totalRemitFees,



              });



            }



          );



        },



      };



    }



    return (

      <div>

        <Table

          locale={locale}

          expandIconAsCell={false}

          expandIconColumnIndex={-1}

          expandedRowKeys={this.state.expandedRowKeys}

          className="bp-table bp-expandable-table orders-table"

          columns={isPartner ? columnsPartner : columns}

          onRowClick={this.onRowClicked}

          expandedRowRender={(order) => {

            if (this.state.expandedRowKeys.indexOf(order.id) > -1) {

              return (

                <OrderInformationPanel

                  key={order.id}

                  {...this.props}

                  labelCancel={labelCancel}

                  customer={this.props.customer}

                  order={order}

                  orderPaymentSlip={this.state.orderPaymentSlip}

                  orderAttachmentFiles={this.state.orderAttachmentFiles}

                  uploaded={this.getOrderAttached}

                  documents={this.state.orderAttachmentFiles}

                  handleRemoveFile={this.handleRemoveFile}

                />

              );

            }

          }}

          rowSelection={rowSelection}

          dataSource={this.props.orders}

          loading={this.props.isLoading}

          onChange={this.props.onChange}

          pagination={this.props.pagination}

          onRow={(order) => {

            return this.state.expandedRowKeys.includes(order.id) && { className: 'expanded-row' };

          }}

          rowKey="id"

        />



      </div>

    );

  }



}



export default withUseIntl(OrdersTable);



